import { TsoNotificationResource } from 'app/tso-notifications/tso-notification.resource';
import * as angular from 'angular';
import * as moment from 'pkp-moment-timezone-all-years';

class TsoNotificationOverviewComponentCtrl implements ng.IController {
    private static readonly QUERY_LAST_DAYS = 30;

    public tsoNotifications: TsoNotificationDto[];
    public loadingError: boolean = false;
    public loadingData: boolean = true;
    public notificationsHaveBeenAvailableInitially: boolean;

    constructor(private tsoNotificationResource: TsoNotificationResource) {}

    public $onInit(): void {
        this.tsoNotificationResource
            .queryAllForTso(
                { sinceDate: this.calculateDate() },
                (res: TsoNotificationDto[]) => {
                    this.tsoNotifications = res;
                    this.loadingError = false;
                    this.loadingData = false;
                },
                () => {
                    this.loadingError = true;
                    this.loadingData = false;
                }
            )
            .$promise.finally(() => {
                this.notificationsHaveBeenAvailableInitially =
                    this.tsoNotifications.length > 0;
            });
    }

    private calculateDate(): Date {
        return moment()
            .subtract(
                TsoNotificationOverviewComponentCtrl.QUERY_LAST_DAYS,
                'days'
            )
            .toDate();
    }
}

angular.module('app').component('pkpTsoNotificationOverview', {
    controller: TsoNotificationOverviewComponentCtrl,
    template:
        require('app/tso-notifications/tso-notification-overview.component.html'),
    bindings: {}
});
